var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tag,{tag:"component",class:_vm.className,style:(_vm.style),attrs:{"href":_vm.href}},[_c('img',{staticClass:"media-image",class:this.circle ? 'rounded-circle' : '',attrs:{"src":_vm.src,"alt":_vm.alt}})])
}
var staticRenderFns = []

export { render, staticRenderFns }